import APIS from "../../constant/Endpoint";
import { tw } from "@careinfo/tailwind";
import Button from "../Reusable/Button";
import PartyWiseSummary from "../Reusable/PartySummary";

import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import useGetHook from "../../customHooks/useGetHook";
// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";

export default () => {
  const reportRef = useRef<HTMLDivElement>(null);
  const { data: clientDetails, isLoading: isClientDetailsLoading } = useGetHook(
    {
      queryKey: ["company-profile"],
      url: `${APIS.COMPANY_PROFILE}`,
    }
  );
  const { data: clientName, isLoading: isClientLoading } = useGetHook({
    queryKey: ["configuration"],
    url: `${APIS.CLIENT_SETTING}`,
  });
  const { data: reportData, isLoading } = useGetHook({
    queryKey: ["party-summary"],
    url: `${APIS.GENERAL_LEDGER}party-wise-summery/`,
  });
  console.log("clientDetails", clientDetails);

  const handleDownloadPDF = async () => {
    if (!reportRef.current) return;

    const canvas = await html2canvas(reportRef.current, {
      scale: 2,
      onclone: (doc) => {
        const header = doc.querySelector(".pdf-header");
        if (header) {
          header.classList.remove("hidden");
        }
      },
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);

    pdf.save("party-wise-summary.pdf");
  };

  const handleDownloadExcel = () => {
    const debtors = reportData?.sundry_debtors || [];
    const creditors = reportData?.sundry_creaditors || [];

    const rows: any[] = [];

    rows.push([clientName?.business_name || "", "", "", ""]);
    rows.push([clientDetails?.address || "", "", "", ""]);
    rows.push([
      `Debtors/Creditors Report as on ${
        new Date().toISOString().split("T")[0]
      }`,
      "",
      "",
      "",
    ]);

    rows.push([]);

    rows.push(["S/N", "A/c Code", "Account Description", "Outstanding Amount"]);

    const creditorsStartRow = rows.length;
    rows.push(["Sundry Creditors", "", "", ""]);

    creditors.forEach((item: any, index: number) => {
      rows.push([
        index + 1 + "  ",
        item?.code,
        item?.full_name,
        Number(item?.outstanding_balance),
      ]);
    });

    const totalCreditors = creditors.reduce(
      (sum: number, item: any) => sum + Number(item?.outstanding_balance),
      0
    );

    const creditorsSubtotalRow = rows.length;

    rows.push(["Sundry Creditors Sub Total", "", "", totalCreditors]);

    rows.push([]);

    const debtorsStartRow = rows.length;

    rows.push(["Sundry Debtors"]);

    debtors.forEach((item: any, index: number) => {
      rows.push([
        index + 1 + "  ",
        item?.code,
        item?.full_name,
        Number(item?.outstanding_balance),
      ]);
    });

    const totalDebtors = debtors.reduce(
      (sum: number, item: any) => sum + Number(item?.outstanding_balance),
      0
    );

    const debtorsSubtotalRow = rows.length;

    rows.push(["Sundry Debtors Sub Total", "", "", totalDebtors]);

    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 3 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 3 } },

      { s: { r: creditorsStartRow, c: 0 }, e: { r: creditorsStartRow, c: 3 } },
      { s: { r: debtorsStartRow, c: 0 }, e: { r: debtorsStartRow, c: 3 } },

      {
        s: { r: creditorsSubtotalRow, c: 0 },
        e: { r: creditorsSubtotalRow, c: 2 },
      },
      {
        s: { r: debtorsSubtotalRow, c: 0 },
        e: { r: debtorsSubtotalRow, c: 2 },
      },
    ];

    const centerStyle = {
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };

    ["A1", "A2", "A3"].forEach((cell) => {
      if (worksheet[cell]) worksheet[cell].s = centerStyle;
    });

    if (worksheet[`A${creditorsSubtotalRow + 1}`]) {
      worksheet[`A${creditorsSubtotalRow + 1}`].s = centerStyle;
    }

    if (worksheet[`A${debtorsSubtotalRow + 1}`]) {
      worksheet[`A${debtorsSubtotalRow + 1}`].s = centerStyle;
    }

    worksheet["!cols"] = [{ wch: 8 }, { wch: 15 }, { wch: 35 }, { wch: 18 }];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Party Summary");

    XLSX.writeFile(workbook, "party-wise-summary.xlsx");
  };

  return (
    <div className={tw`space-y-2`}>
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={handleDownloadPDF} />
        </div>
        <div className={tw`w-32 ml-2`}>
          <Button label="Download Excel" onClick={handleDownloadExcel} />
        </div>
      </div>

      <PartyWiseSummary
        ref={reportRef}
        data={reportData}
        clientDetails={clientDetails}
        clientName={clientName}
      />
    </div>
  );
};

